var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1067.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.63,372.41,410.12,89.94l28.43-21.06c17-7.43,24.23,2.55,27,16V243.16c828.56,73,730.85,864.87,730.85,864.87-27.36,57.65-70.35,0-70.35,0C1087,531.45,465.59,562.2,465.59,562.2V740.91c-.54,14.58-5.48,48.44-41.46,21.8h0L28.63,469.87C-35.78,422.18,28.61,372.42,28.63,372.41Z",
    transform: "translate(0 -66.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.336e5ef33a2f347c95fcd261c8117d83.svg";
export { ForwardRef as ReactComponent };